import {
  IconButton,
  Props as IconButtonProps,
} from "components/Button/IconButton";
import { IconChevronDown } from "components/Icons/IconChevronDown";
import { ClickPopover } from "components/ClickPopover";
import { MenuSelectPerformance } from "shared/SelectPerformance/SelectPerformance";

import type { ActiveContext } from "shared/ContextSwitcher/store";
import type {
  ExecutionTiersData,
  SupportedPublicPerformanceTierKey,
} from "shared/SelectPerformance/useGetPerformanceTiers";

export function PerformanceSettingsButton(props: {
  performance: SupportedPublicPerformanceTierKey;
  setPerformance: (performance: SupportedPublicPerformanceTierKey) => void;
  activeContext: ActiveContext;
  performanceTiers: ExecutionTiersData[];

  buttonTheme?: IconButtonProps["theme"];
}) {
  const { buttonTheme = "tertiary" } = props;

  return (
    <ClickPopover
      position="below-align-right"
      content={({ close }) => (
        // Always render in light mode even though it's within the code
        // editor, which may be in dark mode.
        <div className="lightMode">
          <MenuSelectPerformance
            activeContext={props.activeContext}
            performance={props.performance}
            performanceTiers={props.performanceTiers}
            setPerformance={props.setPerformance}
            close={close}
          />
        </div>
      )}
    >
      <IconButton theme={buttonTheme} size="M">
        <IconChevronDown />
      </IconButton>
    </ClickPopover>
  );
}
